"use client"

import { createContext, useContext, useMemo, type ReactNode } from "react"
import type { KategoriDenganItem } from "@/modules/kontak/domain/types"
import type { LogoMetodeFooter } from "@/modules/payment/domain/metode/logo-footer"
import type { PengaturanUmum } from "@/modules/pengaturan/domain/types"
import type { RingkasanStatus } from "@/modules/status/domain/types"

interface NilaiInfoSitus {
  info: PengaturanUmum
  kontak: KategoriDenganItem[]
  status: RingkasanStatus | null
  metodeBayar: LogoMetodeFooter[]
}

const InfoSitusContext = createContext<NilaiInfoSitus | null>(null)

interface InfoSitusProviderProps {
  info: PengaturanUmum
  kontak: KategoriDenganItem[]
  status: RingkasanStatus | null
  metodeBayar: LogoMetodeFooter[]
  children: ReactNode
}

export function InfoSitusProvider({ info, kontak, status, metodeBayar, children }: InfoSitusProviderProps) {
  const nilai = useMemo(() => ({ info, kontak, status, metodeBayar }), [info, kontak, status, metodeBayar])
  return <InfoSitusContext.Provider value={nilai}>{children}</InfoSitusContext.Provider>
}

export function useInfoSitus(): NilaiInfoSitus {
  const nilai = useContext(InfoSitusContext)
  if (!nilai) throw new Error("useInfoSitus harus dipakai di dalam InfoSitusProvider")
  return nilai
}
